<template>
    <div>
		<div class="page-title">Список лидеров</div>
		<div class="table">
			<table>
				<thead>
					<tr>
						<th>#</th>
						<th>Игрок</th>
						<th>Выигрыш</th>
						<th>Выиграно в Казино</th>
						<th>Выиграно в Режимах</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(user, index) in users" :class="{'success': user && user.id == user.id }">
						<td>{{ index + 1 }}.</td>
						<td>{{ user.username }}</td>
						<td>{{ $root.shortLargeNumber(user.total) }} ₽</td>
						<td>{{ $root.shortLargeNumber(user.casino) }} ₽</td>
						<td>{{ $root.shortLargeNumber(user.games) }} ₽</td>
					</tr>
				</tbody>
			</table>
		</div>
    </div>
</template>

<script>
    import {mapState} from "pinia";
	import {useUserStore} from "../../stores/User.js";

	export default {
        data() {
            return {
                users: []
            }
        },

		computed: {
			...mapState(useUserStore, ['user'])
		},


		methods: {
            fillTable() {
                this.$root.axios.get('/api/user/stats')
                    .then(res => {
                        const data = res.data;
                        this.users = data.users;

                        this.$root.isLoading = false;
                    });
            },
        },
        beforeMount() {
            this.$root.isLoading = true;

            this.fillTable()
        }
    }
</script>